import React, { useState, useEffect } from 'react';
import { formatDate } from '../utility';
import { useTexts } from '../data';

const IVRStatus = ({ data }) => {
  const TEXTS = useTexts();
  const [dataToRender, setDataToRender] = useState([]);

  useEffect(() => {
    const uniqueData = data.filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) => t.mobile === value.mobile && t.date === value.date
        )
    );
    setDataToRender(uniqueData);
  }, [data]);

  return (
    <div className="row mt-3 mb-3" data-component="IVRStatus">
      <div className="col-md-12">
        <div
          className="card ivr-status-card"
          style={{ border: '1px solid #e0e0e0' }}
        >
          <div className="card-body">
            <div className="d-flex align-items-center mb-3">
              <h4 className="fw-bold color mb-0">{TEXTS.IVR_STATUS_TITLE}</h4>
            </div>
            <div className="table-responsive">
              <table className="table ivr-table mb-0">
                <thead>
                  <tr>
                    <th className="mobile-header">{TEXTS.MOBILE_NUMBER}</th>
                    <th className="status-header">{TEXTS.STATUS}</th>
                    <th className="date-header">{TEXTS.DATE}</th>
                  </tr>
                </thead>
                <tbody>
                  {dataToRender.map((entry, index) => (
                    <tr key={index} className="ivr-row">
                      <td className="mobile-cell">
                        <span className="mobile-number">{entry.mobile}</span>
                      </td>
                      <td className="status-cell">
                        <span className="date-text">{entry.status}</span>
                      </td>
                      <td className="date-cell">
                        <span className="date-text">
                          {formatDate(entry.date)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IVRStatus;
